/* global $, moment */
/* eslint-disable-next-line no-multi-assign */
window.$ = window.jQuery = require("jquery");
global.moment = require("moment");
require("tempusdominus-bootstrap-4");

const SELECTOR = ".js-datepicker";
const WIDGET_CLASSNAME = ".bootstrap-datetimepicker-widget";

const DEFAULT_OPTIONS = {
    locale: "ja",
    dayViewHeaderFormat: "YYYY年MM月",
    format: "YYYY/MM/DD",
    useCurrent: "day"
};

const FORMAT_PATTERNS = {
    date: ["YYYY/MM/DD", "YYYY/M/DD", "YYYY/MM/D", "YYYY/M/D"],
    time: ["HH:mm", "H:mm", "HH:m", "HH:mm"]
};

class DatetimePicker {
    static attach() {
        [...document.querySelectorAll(SELECTOR)].forEach((datetimePickerElement) => {
            /* eslint-disable-next-line no-unused-vars */
            const dateTimePicker = new DatetimePicker(datetimePickerElement);
        });
    }

    constructor(datetimePicker) {
        this.datetimePickerElement = datetimePicker;
        this.toggleElement = this.datetimePickerElement.querySelector(
            '[data-toggle="datetimepicker"]'
        );
        this.inputElement = this.datetimePickerElement.querySelector("input");
        this.inputElement.setAttribute("type", "text");
        this.showTime = this.datetimePickerElement.dataset.showTime;
        this.options = { ...DEFAULT_OPTIONS };

        if (this.showTime) {
            this.options.format = "YYYY/MM/DD HH:mm";
            this.options.sideBySide = true;
        }

        if (this.datetimePickerElement.dataset.defaultDate) {
            this.defaultDate = moment(
                this.datetimePickerElement.dataset.defaultDate,
                this.options.format
            );
        }

        this.formatPatterns = [...FORMAT_PATTERNS.date];
        if (this.showTime) {
            FORMAT_PATTERNS.date.forEach((dateFormat) => {
                FORMAT_PATTERNS.time.forEach((timeFormat) => {
                    this.formatPatterns = [...this.formatPatterns, `${dateFormat} ${timeFormat}`];
                });
            });
        }

        this.inputElement.addEventListener("focus", () => {
            $(this.datetimePickerElement).datetimepicker("show");
        });

        this.inputElement.addEventListener("blur", (event) => {
            $(this.datetimePickerElement).datetimepicker("hide");
            this.correctDateFormat(event);
        });

        this.toggleElement.addEventListener("click", (event) => {
            event.stopPropagation();
            $(this.datetimePickerElement).datetimepicker("show");
        });

        window.addEventListener("keydown", (event) => {
            this.handleKeyDown(event);
        });

        $(this.datetimePickerElement).on("show.datetimepicker", () => {
            this.handleDatePickerShow();
        });

        $(this.datetimePickerElement).datetimepicker(this.options);
        if (!this.inputElement.value) {
            this.setToDefaultDate();
        }
    }

    correctDateFormat(event) {
        const inputValue = event.target.value;

        if (!inputValue) {
            this.setToDefaultDate();
            return;
        }

        this.inputElement.value = moment(inputValue, this.formatPatterns).format(
            this.options.format
        );
    }

    setToDefaultDate() {
        $(this.datetimePickerElement).datetimepicker("date", this.defaultDate);
        this.inputElement.value = "";
    }

    toggletimePickerVisibilityPerAction(action) {
        switch (action) {
            case "pickerSwitch":
            case "selectYear":
            case "selectDecade":
                this.datetimePickerElement.dataset.showTimepicker = false;
                break;
            case "selectMonth":
            case "selectDay":
                this.datetimePickerElement.dataset.showTimepicker = true;
                break;
            default:
            // do nothing
        }
    }

    handleKeyDown(event) {
        if (
            this.datetimePickerElement.querySelector(WIDGET_CLASSNAME) &&
            ["Escape", "Enter"].indexOf(event.code) > -1
        ) {
            this.inputElement.blur();
        }
    }

    handleDatePickerShow() {
        [...this.datetimePickerElement.querySelectorAll("[data-action]")].forEach(
            (actionElement) => {
                actionElement.addEventListener("click", (event) => {
                    const { action } = event.target.dataset;
                    this.toggletimePickerVisibilityPerAction(action);
                });
            }
        );
    }
}

export { DatetimePicker };
